var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaestro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5H30C31.933 0.5 33.5 2.067 33.5 4V20C33.5 21.933 31.933 23.5 30 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4C0.5 2.067 2.067 0.5 4 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5H30C31.933 0.5 33.5 2.067 33.5 4V20C33.5 21.933 31.933 23.5 30 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4C0.5 2.067 2.067 0.5 4 0.5Z",
    stroke: "#E4E4E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6289 5C16.2898 5.00006 19.2578 8.0026 19.2578 11.7061C19.2577 15.4094 16.2898 18.4111 12.6289 18.4111C8.96802 18.4111 6.00016 15.4094 6 11.7061C6 8.00257 8.96792 5 12.6289 5Z",
    fill: "#ED0006"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2285 5C24.8895 5.00006 27.8574 8.0026 27.8574 11.7061C27.8573 15.4094 24.8894 18.4111 21.2285 18.4111C17.5676 18.4111 14.5998 15.4094 14.5996 11.7061C14.5996 8.00257 17.5675 5 21.2285 5Z",
    fill: "#0099DF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9287 6.60352C18.3533 7.83341 19.2577 9.66199 19.2578 11.7051C19.2578 13.7481 18.3532 15.5767 16.9287 16.8066C15.5041 15.5767 14.5996 13.7482 14.5996 11.7051C14.5997 9.66194 15.504 7.83341 16.9287 6.60352Z",
    fill: "#6C6BBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestro);
export default __webpack_public_path__ + "static/media/Maestro.df80a5b27ff5441427aaa5c1a2478e07.svg";
export { ForwardRef as ReactComponent };